import { AuthenticationContext } from "../Context";
import * as React from "react";
import { getHeaders } from "../utils/HeaderHelper";

const useFileUpload = () => {
  const authenticationSetting = React.useContext(AuthenticationContext);

  const handleFileUpload = async (formData) => {
    let objectsMetadata = {};
    for (let data of formData) {
      let name = data[0];
      let value = data[1];

      const filename = value?.name;
      const filetype = value?.type;

      const objectMetadata = await createPresignedUrl(
        filename,
        filetype,
        value
      );
      objectsMetadata[name] = objectMetadata;
    }
    return objectsMetadata;
  };

  const createPresignedUrl = async (filename, filetype, formData) => {
    const response = await fetch("/create_presigned_url", {
      method: "POST",
      body: JSON.stringify({ filename: filename }),
      headers: getHeaders(authenticationSetting.csrfToken),
    });

    const result = await response.json();
    if (result) {
      const presignedUrl = result?.presigned_url;
      const objectKey = result?.object_key;

      const uploadResponse = await uploadToS3(
        presignedUrl,
        objectKey,
        filetype,
        formData
      );
      return uploadResponse;
    }
  };

  const uploadToS3 = async (presignedUrl, objectKey, filetype, formData) => {
    const response = await fetch(presignedUrl, {
      method: "PUT",
      body: formData,
      headers: {
        "Content-Type": filetype,
      },
    });

    if (response) {
      const metadata = await getObjectMetadata(objectKey);
      return metadata;
    }
  };

  const getObjectMetadata = async (objectKey) => {
    const response = await fetch(
      `/get_object_metadata?object_key=${objectKey}`,
      {
        method: "GET",
        headers: getHeaders(authenticationSetting.csrfToken),
      }
    );

    const result = await response.json();
    const objectMetadata = result?.object_metadata;
    return objectMetadata;
  };

  return {
    handleFileUpload,
  };
};
export default useFileUpload;